<template>
  <publicExport :exportTypeList="exportTypeList"></publicExport>
</template>
<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import publicExport from "@/components/common/publicExport";
import {setConfigCharacters} from "@/utils/common";

export default {
  name: "exportTask",
  data() {
    return {
      exportTypeList: [
        {value: 'productExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000838')},
        {value: 'inventoryExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000890')},
        {value: 'inventoryLogExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006971')},
        {value: 'packageExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004797')},
        {value: 'ymsInventoryExport', name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000814')}`},
        {value: 'supplierBillExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000496')},
        {value: 'wmsPickupOrderExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006972')},
        {value: 'packageInfoOrderExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')},
        {value: 'packageInfoStockExport', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001739')},
      ]
    };
  },
  components: {
    publicExport
  }
};
</script>

<style scoped>

</style>
